import { makeAutoObservable } from 'mobx'
import { userManager } from '@/Core/Managers'
import type { Notify } from '@/Ship/Contracts/Notify'
import { SavePersonalInfoTask } from '../Tasks/SavePersonalInfoTask'

/**
 * Local store of `PersonalInfo` tab: saves the personal-info fields (lastName, firstName, middleName, email).
 *
 * The profile photo is handled by the shared Ship mechanism
 * (`Ship/Components/UI/UserPhoto`), which is also used from the sidebar menu.
 *
 * After a successful PATCH the response is merged into `userManager.user` —
 * `user` is a public observable field on UserManager, so the sidebar and the
 * profile header update immediately.
 *
 * Status-specific i18n (HTTP 413 etc.) stays at the caller via `describeError`.
 */
export class PersonalInfoStore {
    constructor() {
        makeAutoObservable(this)
    }

    /**
     * PATCH personal-info fields, merge response into `userManager.user`.
     * Returns `true` on success — the view typically does nothing else.
     */
    async submit(
        values: Record<string, any>,
        notify: Notify,
        describeError: (err: any) => Promise<string>
    ): Promise<boolean> {
        const user = userManager.user as any
        const userId = user?.uuid as string
        if (!userId) {
            notify.error('Не вдалося визначити ID користувача')
            return false
        }

        try {
            const response = await SavePersonalInfoTask(userId, values)
            userManager.user = { ...(userManager.user as any), ...(response as any) }
            notify.success('Інформацію успішно оновлено')
            return true
        } catch (err: any) {
            const description = await describeError(err)
            notify.error(description)
            return false
        }
    }
}
